"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Metering = function Metering(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    (0, _extends3.default)({ viewBox: "0 0 60 75", className: "custom-icon" }, props),
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", { d: "m42 63h-20c-2.757 0-5-2.243-5-5v-24.52l-3.124-2.499c-1.192-.954-1.876-2.377-1.876-3.903v-21.078c0-2.757 2.243-5 5-5h30c2.757 0 5 2.243 5 5v21.078c0 1.526-.684 2.95-1.876 3.904l-3.124 2.498v24.52c0 2.757-2.243 5-5 5zm-25-60c-1.654 0-3 1.346-3 3v21.078c0 .916.41 1.77 1.126 2.343l3.874 3.099v25.48c0 1.654 1.346 3 3 3h20c1.654 0 3-1.346 3-3v-25.48l3.874-3.099c.716-.573 1.126-1.427 1.126-2.343v-21.078c0-1.654-1.346-3-3-3z" })
    ),
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", { d: "m46 27h-28c-1.103 0-2-.897-2-2v-18c0-1.103.897-2 2-2h28c1.103 0 2 .897 2 2v18c0 1.103-.897 2-2 2zm-28-20v18h28.001l-.001-18z" })
    ),
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", { d: "m20 15h2v8h-2z" })
    ),
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", { d: "m28 23h-2c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v4c0 1.103-.897 2-2 2zm-2-6v4h2.001l-.001-4z" })
    ),
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", { d: "m36 23h-2c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v4c0 1.103-.897 2-2 2zm-2-6v4h2.001l-.001-4z" })
    ),
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", { d: "m41 15c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4c-.552 0-1 .449-1 1s.448 1 1 1 1-.449 1-1-.448-1-1-1z" })
    ),
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", { d: "m25 35h-2c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2zm-2-4v2h2.001l-.001-2z" })
    ),
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", { d: "m25 43h-2c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2zm-2-4v2h2.001l-.001-2z" })
    ),
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", { d: "m25 51h-2c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2zm-2-4v2h2.001l-.001-2z" })
    ),
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", { d: "m33 35h-2c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2zm-2-4v2h2.001l-.001-2z" })
    ),
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", { d: "m33 43h-2c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2zm-2-4v2h2.001l-.001-2z" })
    ),
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", { d: "m33 51h-2c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2zm-2-4v2h2.001l-.001-2z" })
    ),
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", { d: "m41 35h-2c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2zm-2-4v2h2.001l-.001-2z" })
    ),
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", { d: "m41 43h-2c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2zm-2-4v2h2.001l-.001-2z" })
    ),
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", { d: "m41 51h-2c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2zm-2-4v2h2.001l-.001-2z" })
    ),
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", { d: "m18 53h28v2h-28z" })
    ),
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", { d: "m43 59h-2v-2h2zm-4 0h-2v-2h2zm-4 0h-2v-2h2zm-4 0h-2v-2h2zm-4 0h-2v-2h2zm-4 0h-2v-2h2z" })
    ),
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", { d: "m20 9h2v2h-2z" })
    ),
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", { d: "m24 9h8v2h-8z" })
    )
  );
};

exports.default = Metering;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/metering.js
// module id = 1798
// module chunks = 895